module.exports = __webpack_public_path__ + "media/images/copy_icon_dark-5c56889f.svg";